//#region Imports
import React from "react";

import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { WarehouseTable } from "../components/Tables/WarehouseTable";
//#endregion

function InventoryStore() {
  const { titleInventoryString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleInventoryString}</title>
      </Helmet>
      <div className="datatable">
        <WarehouseTable />
      </div>
    </div>
  );
}

export default InventoryStore;